import TimberStorageName from "./TimberStorageName";
import TimberStorageLink from "./TimberStorageLink";

import CuttingName from "../../../../timber/components/cutting/CuttingDetail/CuttingName";
import CuttingLink from "../../../../timber/components/cutting/CuttingDetail/CuttingLink";

import LocationName from "../../../../location/components/location/LocationDetail/LocationName";
import LocationLink from "../../../../location/components/location/LocationDetail/LocationLink";

import ForestOwnerName from "../../../../timber/components/forestOwner/ForestOwnerDetail/ForestOwnerName";
import ForestOwnerLink from "../../../../timber/components/forestOwner/ForestOwnerDetail/ForestOwnerLink";
import { toStringDisplay as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { toStringDisplay as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { toStringDisplay as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { toStringDisplay as toStringUserType } from "../../../types/models/UserType.d";
import { toStringDisplay as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import {NavLink, useParams} from "react-router";

import Grid from '@mui/material/Grid';
import { Refresh, Clear, CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const TimberStorageDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" spacing={1} sx={{ justifyContent: "left" }}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="TimberStorage-detail-title"
                    >
                        { label || t`Timber Storage` }: <TimberStorageName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ justifyContent: "right" }}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="TimberStorage-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="TimberStorage-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    <Grid size={ {xs: 4} } data-testid="name-label" sx={{ textAlign: "left" }}><Trans>Name</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="name-value" sx={{ textAlign: "left" }}>{ data.name || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="cuttingId-label" sx={{ textAlign: "left" }}><Trans>Cutting</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="cuttingId-value" sx={{ textAlign: "left" }}>{ data.cuttingId ? (<CuttingLink id={ data.cuttingId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="locationId-label" sx={{ textAlign: "left" }}><Trans>Location</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="locationId-value" sx={{ textAlign: "left" }}>{ data.locationId ? (<LocationLink id={ data.locationId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="forestOwnerId-label" sx={{ textAlign: "left" }}><Trans>Forest Owner</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="forestOwnerId-value" sx={{ textAlign: "left" }}>{ data.forestOwnerId ? (<ForestOwnerLink id={ data.forestOwnerId }/>) : '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default TimberStorageDetail;
